/* PLAYER */
soundManager.setup({
  onready: function () {
  }
});

var Player = function () {
};

rv.observe('player', function () {
  rv.get('status.detailedView.active') ? rv.get('status.detailedView.rv').set('player', rv.get('player')) : '';
}, { init: false });

Player.prototype.action = function (e, act) {
  var id = e.context.id || this.id;
  rv.set('player.id', id);
  var sound = soundManager.getSoundById(id),
    t = this;
  if (!sound) {
    sound = soundManager.createSound({
      id: id,
      url: e.context.previewURL,
      whileplaying: function () {
        rv.set('player.percent', this.position / this.durationEstimate * 100);
      },
      onplay: function () {
        rv.set('player.state', 'playing');
      },
      onresume: function () {
        rv.set('player.state', 'playing');
      },
      onpause: function () {
        rv.set('player.state', 'paused');
      },
      onstop: function () {
        rv.set('player.state', 'paused');
      }
    });
  }

  if (id !== t.id) {
    rv.set('player.percent', 0);
    if (t.audio) t.audio.stop();
    t.id = id;
    t.audio = sound;
  }

  if (!act) return;

  t[ act ](e.original);
};

Player.prototype.seek = function (e) {
  var t = this;
  if (t.audio.playState === 0) {
    t.audio.play({
      onload: function () {
        var x = e.pageX - $(e.target).offset().left,
          width = $(e.target).width();
        t.audio.setPosition((x / width) * t.audio.durationEstimate);
      }
    });
  } else {
    var x = e.pageX - $(e.target).offset().left,
      width = $(e.target).width();
    t.audio.setPosition((x / width) * t.audio.durationEstimate);
    if (t.audio.paused) {
      t.audio.play();
    }
  }
};

Player.prototype.toggle = function () {
  this.audio.togglePause();
};

Player.prototype.back = function () {
  this.audio.setPosition(this.audio.position > 5000 ? this.audio.position - 5000 : 0);
};

Player.prototype.forward = function () {
  this.audio.setPosition(this.audio.position + 5000 < this.audio.duration ? this.audio.position + 5000 : this.audio.duration - 5000);
};

inf.player = new Player();

rv.on('audio', function (e, act) {
  e.original.preventDefault();
  e.original.stopPropagation();
  inf.player.action(e, act);
});
